<template>
  <div class="content-detail">
    <van-loading type="spinner" v-if="nodata"/>
    <div class="about">
      <span v-if="dominItem.templateId === 'temp3'" style="font-size: 20px; color: #333333">{{ dominItem.logoName || 'Logo' }}</span>
      <div>
        <span>{{ nowDate }}</span>
        <span @click="$router.push('/')" style="margin: 0 20px">{{ $t('con_home') }}</span>
        <span @click="$router.push('/')">{{ $t('con_about') }}</span>
      </div>
    </div>

    <div class="logo" v-if="dominItem.templateId === 'temp1' || dominItem.templateId === 'temp3'">
      <span class="logo-name" v-if="dominItem.templateId !== 'temp3'">{{ dominItem.logoName || 'Logo' }}</span>
      <div class="category" :class="[dominItem.templateId === 'temp3' ? 'catetemp3' : '']">
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
      </div>
    </div>

    <div class="logo" style="justify-content: space-between" v-if="dominItem.templateId === 'temp2'">
      <div class="category categtemp2">
        <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
            item.label
          }}</span>
      </div>
      <span class="logo-name" style="text-align: right">{{ dominItem.logoName || 'Logo' }}</span>
    </div>

    <div class="contentA" v-if="bestInfo">
      <span class="title" style="margin-top: 30px">{{ bestInfo.articleTitle }}</span>
      <span class="time">
        <span>{{ $t('con_time') }}</span>
        <span style="margin-left: 20px">{{ bestInfo.uploadTime }}</span>
        <span style="margin: 0 20px" class="see-number">{{ $t('con_see') }}</span>
        <span class="number">{{ bestInfo.articleReadNum }}</span>
      </span>

      <div class="icon-big"  v-if="dominItem.nationId !== 'cn'">
        <img  v-for="item in iconListbig" @click="openLink(item.link)" :src="item.url" alt="">
      </div>

      <div style="margin-top: 30px" v-for="item in videoList">
        <video ref="videoRef" :src="item.url" width="650" height="400" controls ></video>
      </div>

      <div class="detail" v-html="bestInfo.articleContent">
      </div>

      <div class="icon-big" style="margin-top: 30px"  v-if="dominItem.nationId !== 'cn'">
        <img  v-for="item in iconListlarge" @click="openLink(item.link)" :src="item.url" alt="">
      </div>

      <div class="next">
        <div class="prve" @click="getPage(previousPost.articleShortName)" v-if="previousPost">
          <span>
          <img src="../../assets/prve.jpg" alt="">
            <!--            -->
          <span>{{ $t('con_PREV') }}</span>
          </span>
          <div>
            {{ previousPost.articleTitle }}
          </div>
        </div>
        <div class="nexta" @click="getPage(nextChapter.articleShortName)" v-if="nextChapter">
          <span>
<!--            -->
          <span>{{ $t('con_NEXT') }}</span>
          <img style="position: relative; top: -4px" src="../../assets/next.png" alt="">
          </span>
          <div style="text-align: right">{{ nextChapter.articleTitle }}
          </div>
        </div>
      </div>
      <div class="hot" style="margin-top: 50px"><span class="hot-name">{{ $t('con_also') }}</span></div>
      <div class="last-news cat-news">
        <div class="last-news-content">
          <div v-for="(item,index) in recommendArticle" class="content-box" @click="getPage(item.articleShortName)">
            <template v-if="index < 6">
              <div class="bot-img">
                <img :src="item.articleImage || defaultImg" alt=""></div>
              <div style="display: flex; margin-top: 10px">
                <span style="margin: 0 20px 0 0" class="see-number">{{ $t('con_see') }}</span>
                <span class="number">{{ item.articleReadNum }}</span>
              </div>
              <div class="last-news-content-box" style="padding-top: 0px">
                <span class="title">{{ item.articleTitle }}</span>
              </div>
              <div class="time" style="margin-top: 0">
                <span class="country">{{ $t('con_time') }}</span>
                <span style="color: #9a9a9a; font-size: 12px;">{{ item.uploadTime }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="footer" v-if="dominItem.nationId === 'cn'" style="background: #EFEFEF; padding-top: 30px; padding-bottom: 0">
      <div class="tips">
        <van-icon name="warning-o"/>
        <span style="color: #000000">免责声明</span>
        <div>登载此文出于传递更多信息之目的，并不意味着赞同其观点或证实其描述。文章内容仅供参考，不构成投资建议，如有侵权，请及时联系删除。</div>
      </div>
    </div>

    <div class="footer" :style="{ marginTop: dominItem.nationId === 'cn' ? '0' : '' }">
      <span>© 2023 - {{ dominItem.logoName || 'Logo' }}. All Rights Reserved. Website: {{ dominItem.logoName || 'Logo' }}</span>
    </div>

  </div>
</template>
<script>
import {getInfo} from "@/api";
import {format} from "date-fns";
import Clipboard from 'clipboard';
import {Toast} from 'vant';
import {Base64} from "js-base64";

export default {
  props: {
    dominItem: Object
  },
  data() {
    return {
      nodata: false,
      current: 1,
      currentPage: 1,
      defaultImg: undefined,
      videoList: [],
      bestInfo: undefined,
      nextChapter: undefined,
      previousPost: undefined,
      recommendArticle: [],
      clipboardText: window.location.href,
      iconListbig: [
        {url: require('../../assets/icon/icon.png'), link: ''},
        {url: require('../../assets/icon/icon1.png'), link: 'https://www.facebook.com/'},
        {url: require('../../assets/icon/icon2.png'), link: 'https://twitter.com/'},
        {url: require('../../assets/icon/icon3.png'), link: 'https://www.google.com/'},
        {url: require('../../assets/icon/icon4.png'), link: 'https://www.reddit.com/'},
        {url: require('../../assets/icon/icon5.png'), link: 'https://www.pinterest.com/'},
        {url: require('../../assets/icon/icon6.png'), link: 'mailto:#'},
      ],

      iconListlarge: [
        {url: require('../../assets/icon/icon.png'), link: ''},
        {url: require('../../assets/icon/icon-large1.png'), link: 'https://www.facebook.com/'},
        {url: require('../../assets/icon/icon-large2.png'), link: 'https://twitter.com/'},
        {url: require('../../assets/icon/icon-large3.png'), link: 'https://www.google.com/'},
        {url: require('../../assets/icon/icon-large4.png'), link: 'https://www.reddit.com/'},
        {url: require('../../assets/icon/icon-large5.png'), link: 'https://www.pinterest.com/'},
        {url: require('../../assets/icon/icon-large6.png'), link: 'mailto:#'},
      ],

      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7}],
    };
  },

  created() {
    this.getPageInfo(this.$route.params.name)
    this.current = Number(this.$route.query.type)
    this.nowDate = format(new Date(),  this.$t('con_format'))
    this.defaultImg = JSON.parse(localStorage.getItem('dominItem')).defaultImg
  },

  methods: {
    // 根据文章id获取文章详情
    getPageInfo(name) {
      this.nodata = true
      getInfo({name: name, articleNationId: this.dominItem.nationId, domain: this.dominItem.domainName}).then(res => {
        let Base64 = require('js-base64').Base64;
        this.bestInfo = res.data.articleInfo
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
        this.bestInfo.articleContent = Base64.decode(this.bestInfo.articleContent);
        this.nextChapter = res.data.nextChapter
        this.videoList = JSON.parse(this.bestInfo.remark)
        this.previousPost = res.data.previousPost
        this.recommendArticle = res.data.recommendArticle
        this.nodata = false
      })
    },

    openLink(link) {
      window.open(link)
    },


    getPage(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    },

    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.$router.push(`/?type=${item}`)
    },
  },
};
</script>
<style lang="scss" scoped>
@import "dkr";
@import "../index/kr";
</style>
